import React from "react";
import "./App.css";
import MainLayout from "./pages/MainLayout";
import { Routes, Route } from "react-router-dom";
import { LoginPage } from "./pages/LoginPage";
import ProtectedRoute from "./pages/ProtectedRoute";

const App: React.FC = () => {
  // console.log('instanceId App')
  return (
    <div className="App">
      <main className="container content">
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route element={<ProtectedRoute />}>
            <Route path="*" element={<MainLayout />} />
          </Route>
          {/* <Route path='/user-profile' element={<ProfileScreen />} /> */}
        </Routes>
      </main>
    </div>
  );
};

export default App;
